export default "__VITE_ASSET__W8OC4smQ__"